import type { FC } from "react";

import { Typography } from "@aviary";
import type { TypographyType } from "@aviary/components/Typography";

import * as styles from "./ProductName.styles";

interface Props {
  name: string;
  changeOnHover?: boolean;
  isNoClip?: boolean;
  wordWrap?: boolean;
  type?: TypographyType;
}

const ProductName: FC<Props> = ({ name, changeOnHover, isNoClip, wordWrap, type, ...rest }) => {
  const getProductNameStyles = [
    styles.productName.base,
    changeOnHover && styles.productName.changeOnHover,
    isNoClip && styles.productName.noClip,
    !wordWrap && styles.nowrap,
  ];

  return (
    <Typography css={getProductNameStyles} type={type} title={name} {...rest}>
      {name}
    </Typography>
  );
};

ProductName.defaultProps = {
  type: "h4",
  changeOnHover: true,
};

export { ProductName };
